export default __webpack_public_path__ + "static/casecard6-59b7f2c7b85388be3c086aa4bcccf839.jpg";